export default __webpack_public_path__ + "static/media/blog-action.ed803f66.webp";